import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Box,
  Typography,
} from '@mui/material';

const fetchModelsApi = async (apiModel, page = 0, pageSize = 10) => {
  try {
    const response = await axios.get(
      `/api/${apiModel}?page=${page}&pageSize=${pageSize}`
    );
    switch (apiModel) {
      case 'floors':
        return response.data.floors;
      case 'locations':
        return response.data.locations;
      case 'util/order_statuses':
        return response.data.orderStatuses;
      default:
        throw new Error(`Modelo API desconocido: ${apiModel}`);
    }
  } catch (error) {
    console.error("Error al obtener items de la API:", error);
    throw new Error("No se pudieron cargar los items. Error de red o del servidor.");
  }
};

function DynamicSelect({ apiModel, componentLabel = "Producto", onItemChange, defaultValue, onDataLoaded  }) {
  const [selectedItem, setSelectedItem] = useState(defaultValue || '');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

useEffect(() => {
  setSelectedItem(defaultValue || '');
}, [defaultValue]);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        setLoading(true);
        const data = await fetchModelsApi(apiModel, 0, 50);
        setItems(data);
        if (onDataLoaded) {
          onDataLoaded(data); // Notifica al padre
        }
        setError(null);
      } catch (err) {
        console.error('Error al cargar items:', err);
        setError('No se pudieron cargar los items. Inténtalo de nuevo más tarde.');
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []); // El array vacío asegura que se ejecute solo una vez al montar el componente

  const handleChange = (event) => {
    setSelectedItem(event.target.value);
    onItemChange && onItemChange(event.target.value);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 100 }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Cargando items...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 100 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="product-select-label">{componentLabel}</InputLabel>
      <Select
        labelId="product-select-label"
        id="product-select"
        value={selectedItem}
        label={componentLabel}
        onChange={handleChange}
        disabled={items.length === 0} // Deshabilita si no hay items
      >
        <MenuItem value="">
          <em>Selecciona {componentLabel}</em>
        </MenuItem>
        {items.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
      {/* {selectedItem && (
        <Typography variant="body2" sx={{ mt: 2 }}>
          Has seleccionado: {items.find(p => p.id === selectedItem)?.name}
        </Typography>
      )} */}
    </FormControl>
  );
}

export default DynamicSelect;